import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { environment } from "environment";
import { homeUrl } from "src/app/common/utils/home-route.util";

@Component({
  selector: "app-zpax-logo",
  templateUrl: "./zpax-logo.component.html",
  styleUrls: ["./zpax-logo.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterLink],
})
export class ZpaxLogoComponent {
  enableNewReactApp = environment.enableNewReactApp;
  homeUrl = homeUrl();
}
